// extracted by mini-css-extract-plugin
export default {"modal":"layout_modal__fuTJq","panel":"layout_panel__YxaSi"};